export default __webpack_public_path__ + "f514ecc797565cd99c4ec455d5e3d43d.png";